import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"];

/* eslint react/prefer-stateless-function: 0 */
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, warnOnce, tagPropType } from './utils';
var defaultProps = {
  type: 'text'
};
var Input = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Input, _React$Component);
  function Input(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.getRef = _this.getRef.bind(_assertThisInitialized(_this));
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = Input.prototype;
  _proto.getRef = function getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }
    this.ref = ref;
  };
  _proto.focus = function focus() {
    if (this.ref) {
      this.ref.focus();
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      cssModule = _this$props.cssModule,
      type = _this$props.type,
      bsSize = _this$props.bsSize,
      valid = _this$props.valid,
      invalid = _this$props.invalid,
      tag = _this$props.tag,
      addon = _this$props.addon,
      plaintext = _this$props.plaintext,
      innerRef = _this$props.innerRef,
      attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
    var isNotaNumber = new RegExp('\\D', 'g');
    var fileInput = type === 'file';
    var textareaInput = type === 'textarea';
    var selectInput = type === 'select';
    var rangeInput = type === 'range';
    var Tag = tag || (selectInput || textareaInput ? type : 'input');
    var formControlClass = 'form-control';
    if (plaintext) {
      formControlClass = formControlClass + "-plaintext";
      Tag = tag || 'input';
    } else if (fileInput) {
      formControlClass = formControlClass + "-file";
    } else if (rangeInput) {
      formControlClass = formControlClass + "-range";
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = 'form-check-input';
      }
    }
    if (attributes.size && isNotaNumber.test(attributes.size)) {
      warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
      bsSize = attributes.size;
      delete attributes.size;
    }
    var classes = mapToCssModules(classNames(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
    if (Tag === 'input' || tag && typeof tag === 'function') {
      attributes.type = type;
    }
    if (attributes.children && !(plaintext || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
      warnOnce("Input with a type of \"" + type + "\" cannot have children. Please use \"value\"/\"defaultValue\" instead.");
      delete attributes.children;
    }
    return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes,
      "aria-invalid": invalid
    }));
  };
  return Input;
}(React.Component);
Input.defaultProps = defaultProps;
export default Input;